import { featureFlags } from 'config/featureFlags';

export const floormapSourceNtileCount = 6;
export const floormapHeatBeanCount: 5 | 6 = 5;

// Figma map color key (12167:66335 / 12167:67012) — pure white center step.
export const floormapMergedNeutralColor = '#fcfcfc';
export const floormapMergedNeutralLightColor = 'rgba(252, 252, 252, 0.2)';

/** Full 5-step floormap legend colors from Figma alt map bar (12167:67010–67014). */
export const floormapLegendColors = {
  5: '#f50d8c',
  4: '#f76cad',
  3: '#fcfcfc',
  2: '#7fd0e5',
  1: '#04a3da',
} as const;

/** Inactive (narrow) legend steps — three distinct charcoal shades, not one flat bar. */
export const floormapLegendInactiveColors = {
  5: '#525960',
  4: '#4b5158',
  3: '#4b5158',
  2: '#3f454c',
  1: '#363c42',
} as const;

const isFiveBeanFloormap = floormapHeatBeanCount === 5;

const getFloormapHeatOrder = (beanCount: 5 | 6): number[] => {
  if (beanCount === 6) {
    return [6, 5, 4, 3, 2, 1];
  }

  return [5, 4, 3, 2, 1];
};

export const heatLegendAllInsight: number[] = getFloormapHeatOrder(floormapHeatBeanCount);

export const heatLegendJackpots: number[] = heatLegendAllInsight.slice(0, 3);

// When jackpotGoldColors is disabled this always returns false so all callers
// (map layer colors, heat legend) fall back to the standard pink/warm scale.
export const isJackpotInsight = (insight: string): boolean =>
  featureFlags.jackpotGoldColors &&
  (insight === 'jackpots' || insight === 'jackpot_value');

export const floormapTopHeatScale = floormapHeatBeanCount;
export const floormapJackpotColdHeatScale = isFiveBeanFloormap ? 3 : 4;

export const mapNtileToFloormapHeat = (ntile: number): number => {
  if (!isFiveBeanFloormap) {
    return ntile;
  }

  switch (ntile) {
    case 6:
      return 5;
    case 5:
      return 4;
    case 4:
    case 3:
      return 3;
    case 2:
      return 2;
    case 1:
      return 1;
    default:
      return ntile;
  }
};